/** Farm storefront / pickup location */
export const FARM_ADDRESS_LINE = '180 N Catharine St';
export const FARM_ADDRESS_CITY = 'Montour Falls, NY · Finger Lakes Region';
/** Single line for checkout / confirmations */
export const FARM_ADDRESS_ONE_LINE = '180 N Catharine St, Montour Falls, NY';
